import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Navbar from '../../components/navbar';
import Icon from '../../components/icon/Icon';
import BaseModal from '../../components/modal/BaseModal';
import Button from '../../components/button/Button';
import Location from '../view/Location';
import Content from './Content';
import InputItem from '../../components/input-item/InputItem';
import Toast from '../../components/toast/Toast';
import Message from '../../components/message';
import nativeInterface from '../../native-interact/native';
import { operateModes, theme } from '../../mobx/stores/global';
import { MODE } from '../../mobx/stores/step';
import { getImgCodeUrl, getUserInfo, sendSmsCode, verifySmsCode, getAppVersion } from '../../service';
import themeType from '../../assets/imgs/themeType.png';
import { downloadUpgradeFile, getAppInfo } from '../../native-interact/native-interface';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLocation: false,
      showLocationIcon: true,
      showSwitchMode: false,
      headerColor: '',
      headerFontColor: '',
      fontColor: '',
      contentClass: '',
      tempLocation: [],
      showAuth: false,
      imgCodeUrl: getImgCodeUrl(),
      imgCodeValue: '',
      smsCode: '',
      phone: '',
      sendCodeDesc: '获取验证码',
      showThemeMode: false,
      showMask: false,
      url: ''
    };
    setTimeout(() => {
      const android = !!navigator.userAgent.match(/Android/i);
      const ios = !!navigator.userAgent.match(/iPhone/i);
      if (android || ios) {
        getAppInfo().then((data) => {
          const localV = data[0].appVersionName;
          this.getAppVersion(localV);
        });
      }
    }, 400);

    this.showSwitchMode = this.showSwitchMode.bind(this);
  }

  getAppVersion(localAppVersion) {
    if (localAppVersion) {
      getAppVersion(
        {
          appVersion: localAppVersion
        }
      ).then((res) => {
        this.setState({
          showMask: res.flag,
          url: res.url
        });
      });
    }
  }

  componentDidMount() {
    // this.switchMode(operateModes[3]);
    // 根据全局主题状态 设置调试工具主页主题风格 dark light
    this.setTheme(this.props.globalStore.themeType);
  }

  // eslint-disable-next-line no-shadow
  setTheme(themeType) {
    this.setState({
      headerColor: theme[themeType].headerColor,
      headerFontColor: theme[themeType].headerFontColor,
      fontColor: theme[themeType].fontColor,
      showLocationIcon: theme[themeType].showLocationIcon,
      contentClass: theme[themeType].contentClass || ''
    });
    document.body.style.background = theme[themeType].bgColor;
    localStorage.setItem('themeType', themeType); // 本地缓存主题颜色 下次进入页面时在全局状态中做查询用
    this.props.globalStore.themeType = themeType;
    nativeInterface.setStatusBarColor(theme[themeType].headerColor);
    this.setState({
      showThemeMode: false
    });
  }

  showTheme = () => {
    // 显示主题色弹窗
    this.setState({
      showThemeMode: true
    });
  }

  hideTheme = () => {
    // 隐藏主题色弹窗
    this.setState({
      showThemeMode: false
    });
  }

  // eslint-disable-next-line react/sort-comp
  onLocationChange(location) {
    this.setState({
      tempLocation: location
    });
  }

  onLocationConfirm() {
    if (this.state.tempLocation.length === 2) {
      this.props.parkStore.form.lon = this.state.tempLocation[0];
      this.props.parkStore.form.lat = this.state.tempLocation[1];
    } else {
      // app定位失效 默认定位值 保证正常提交
      // this.props.parkStore.form.lon = '116.407041';
      // this.props.parkStore.form.lat = '39.907123';
    }
    this.hideLocation();
  }

  onBack() {
    Message.confirm('确定退出安装调试？', () => {
      nativeInterface.finishActivity();
    }, () => {});
  }

  onImgCodeChange(e) {
    this.setState({
      imgCodeValue: e.target.value
    });
  }

  onSmsCodeChange(e) {
    this.setState({
      smsCode: e.target.value
    });
  }

  onAuth() {
    verifySmsCode(this.state.phone, this.state.smsCode)
      .then(() => {
        this.gotoMode(operateModes[2]);
      })
      .catch(() => {});
  }

  // 显示定位弹窗
  showLocation() {
    this.setState({
      showLocation: true
    });
  }

  // 隐藏定位弹窗
  hideLocation() {
    this.setState({
      showLocation: false
    });
  }

  showSwitchMode() {
    this.setState({
      showSwitchMode: true
    });
  }

  hideSwitchMode() {
    this.setState({
      showSwitchMode: false
    });
  }

  switchMode(mode) {
    // 关闭弹窗
    this.hideSwitchMode();

    if (mode.mode === MODE.DETECT) {
      this.gotoMode(mode);
      return;
    }

    if (this.props.globalStore.operateMode === MODE.AUTO) {
      if (!this.props.readStore.RFID) {
        Toast.fail('请先开始安装，获取地磁序列号');
        return;
      }
      if (this.props.globalStore.status === 'loading') {
        Toast.fail('正在安装中，请等待完成');
        return;
      }
    }

    if (mode.mode === MODE.EXPERT) {
      this.gotoExpert();
      return;
    }

    this.gotoMode(mode);
  }

  gotoMode(mode) {
    // 更改背景及导航栏主题色
    this.props.globalStore.operateMode = mode.mode;
    this.setState({
      // headerColor: mode.headerColor,
      // headerFontColor: mode.headerFontColor,
      // fontColor: mode.fontColor,
      showLocationIcon: mode.mode === MODE.AUTO,
      // contentClass: mode.contentClass || ''
    });
    // document.body.style.background = mode.bgColor;
    // nativeInterface.setStatusBarColor(mode.headerColor);
  }

  gotoExpert() {
    // 直接进入专家模式
    this.gotoMode(operateModes[2]);
    // this.setState({
    //   showAuth: true
    // });
  }

  hideAuth() {
    this.setState({
      sendCodeDesc: '获取验证码',
      imgCodeValue: '',
      smsCode: '',
      showAuth: false
    });
  }

  sendSmsCode() {
    getUserInfo().then((data) => {
      if (data.cellphoneNo) {
        this.setState({
          phone: data.cellphoneNo
        });
        sendSmsCode(data.cellphoneNo, this.state.imgCodeValue).then(() => {
          let count = 60;
          setInterval(() => {
            count -= 1;
            let desc = `${count}后重新获取`;
            if (count <= 0) {
              desc = '获取验证码';
            }
            this.setState({
              sendCodeDesc: desc
            });
          }, 1000);
        });
      } else {
        Toast.fail('该账户未配置手机号');
      }
    });
  }

  refreshImgCode() {
    this.setState({
      imgCodeUrl: getImgCodeUrl()
    });
  }


  render() {
    const {
      showLocation,
      showSwitchMode,
      showLocationIcon,
      headerColor,
      headerFontColor,
      fontColor,
      contentClass,
      showAuth,
      imgCodeUrl,
      smsCode,
      imgCodeValue,
      sendCodeDesc,
      showThemeMode,
      showMask,
      url
    } = this.state;
    const isAndroid = !!navigator.userAgent.match(/Android/i);
    const { parkStore, readStore, globalStore } = this.props;
    const SmsComponent = (() => {
      return <Button disabled={sendCodeDesc !== '获取验证码'} onClick={() => this.sendSmsCode()}>{sendCodeDesc}</Button>;
    })();
    const down = () => {
      downloadUpgradeFile('app', url);
      Message.alert('正在下载升级文件，请在升级后重新进入该页面', () => {
        nativeInterface.finishActivity();
      });
    };
    return (
      <div>
        <div className="Mask" style={{ display: !showMask ? 'none' : 'inline-block' }}>
          <div className="tip">
            <div className="title">提示</div>
            {isAndroid ? 'App版本过低，请前往下方地址进行升级' : 'App版本过低，请前往应用商店进行升级'}

            <div className="content" style={{ display: isAndroid ? 'flex' : 'none' }}>
              <Button type="primary" shape="round" size="small" onClick={() => down()}>
                下载
              </Button>
            </div>
            <div className="content" style={{ display: !isAndroid ? 'flex' : 'none' }}>
              <Button
                type="primary"
                shape="round"
                size="small"
                onClick={() => {
                  this.setState({
                    showMask: false
                  });
                }}
              >
                确认
              </Button>
            </div>
          </div>
        </div>
        <div className="header-navbar" style={{ background: headerColor, color: headerFontColor }}>
          <Navbar
            title={<span>安装调试<span className="navbar-title--dt">{readStore.projectParam.communicateType.value}</span></span>}
            rightContent={
              <div>
                <Icon className="theme-mode" onClick={() => this.showTheme()}>
                  <img alt="" src={themeType} />
                </Icon>
                <Icon icon="qiehuan" onClick={() => this.showSwitchMode()} />
                {
                  showLocationIcon ? <Icon icon="dingwei" style={{ marginLeft: 10 }} onClick={() => this.showLocation()} /> : ''
                }
              </div>
            }
            onBack={this.onBack}
          />
        </div>
        <main className={['main-content', contentClass].join(' ')} style={{ color: fontColor }}>
          <Content {...this.props} />
        </main>
        <BaseModal
          title="切换主题颜色"
          visible={showThemeMode}
          onCloseModal={() => this.hideTheme()}
          showFooter={false}
        >
          {
            globalStore.themeType === 'dark'
              ? <Button type="ghost" className="mode-btn" onClick={() => this.setTheme('light')}>浅色</Button>
              : <Button type="ghost" className="mode-btn" onClick={() => this.setTheme('dark')}>深色</Button>
          }
        </BaseModal>
        <BaseModal
          title="车位定位"
          visible={showLocation}
          onCloseModal={() => this.hideLocation()}
          onConfirm={() => this.onLocationConfirm()}
        >
          <Location
            defaultLocation={
              parkStore.form.lon && parkStore.form.lat
                ? [parkStore.form.lon, parkStore.form.lat]
                : []
            }
            onLocationChange={location => this.onLocationChange(location)}
          />
        </BaseModal>
        <BaseModal
          title="切换操作模式"
          visible={showSwitchMode}
          onCloseModal={() => this.hideSwitchMode()}
          showFooter={false}
        >
          <ul>
            {
              operateModes.map((item) => {
                if (item.mode !== globalStore.operateMode) {
                  return (
                    <li key={item.desc}>
                      <Button type="ghost" className="mode-btn" onClick={() => this.switchMode(item)}>{item.desc}</Button>
                    </li>
                  );
                }
                return '';
              })
            }
          </ul>
        </BaseModal>
        <BaseModal
          title="身份验证"
          visible={showAuth}
          onCloseModal={() => this.hideAuth()}
          onConfirm={() => this.onAuth()}
        >
          <InputItem
            prefix="auth-input"
            label=""
            placeholder="请输入图形验证码"
            extra={
              <img src={imgCodeUrl} alt="图形验证码" onClick={() => this.refreshImgCode()} />
            }
            value={imgCodeValue}
            onChange={e => this.onImgCodeChange(e)}
          />
          <InputItem
            prefix="auth-input"
            label=""
            placeholder="请输入短信验证码"
            extra={SmsComponent}
            value={smsCode}
            onChange={e => this.onSmsCodeChange(e)}
          />
        </BaseModal>
      </div>
    );
  }
}

export default observer(Index);
